import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import GroupsIcon from "@mui/icons-material/Groups";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { EmptyState } from "../common/EmptyState";
import { EntityListCard } from "../common/EntityListCard";
import { SeeAllButton } from "../utils/CardActions";
import { TeamAvatar } from "./TeamAvatar";
const MAX_TEAMS_TO_SHOW = 5;
export const TeamsCard = ({ teams, isOwnProfile, }) => {
    const showViewAll = teams.length > MAX_TEAMS_TO_SHOW;
    const teamsToDisplay = teams.slice(0, MAX_TEAMS_TO_SHOW);
    return (_jsx(EntityListCard, { heading: "Teams", count: teams.length, headerAction: showViewAll && _jsx(SeeAllButton, { to: "/teams" }), items: teamsToDisplay, renderRow: (team, index, items) => (_jsx(Link, { to: `/teams/${team.id}/`, style: { textDecoration: "none", color: "inherit", width: "100%" }, children: _jsxs(Box, { sx: {
                    py: 1.5,
                    px: 2,
                    display: "flex",
                    alignItems: "center",
                    "&:hover": { backgroundColor: "#f8f9ff" },
                    transition: "all 0.2s ease",
                    borderBottom: index < items.length - 1
                        ? "1px solid rgba(0,0,0,0.08)"
                        : "none",
                }, children: [_jsx(TeamAvatar, { team: team }), _jsx(Typography, { variant: "body1", sx: { ml: 2, fontWeight: 600 }, children: team.name })] }) }, team.id)), emptyState: _jsx(EmptyState, { icon: _jsx(GroupsIcon, {}), heading: "No teams yet", description: isOwnProfile ? "Create a team to get started." : undefined, actionLabel: isOwnProfile ? "Create Team" : undefined, actionTo: isOwnProfile ? "/teams/create/" : undefined }) }));
};
